import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { map } from 'lodash-es'

import { Input } from '@/components/ui'
import FormGroup from '@/core/components/FormGroup'

import { IArtistValues } from './types'

type SocialField = {
  name:
    | 'webLink'
    | 'fbLink'
    | 'twLink'
    | 'youtubeLink'
    | 'igLink'
    | 'tiktokLink'
  label: string
  placeholder: string
}

const SOCIAL_FIELDS: SocialField[] = [
  {
    name: 'webLink',
    label: 'Website (Optional)',
    placeholder: 'Enter Website URL',
  },
  {
    name: 'fbLink',
    label: 'Facebook URL (Optional)',
    placeholder: 'Enter Facebook URL',
  },
  {
    name: 'twLink',
    label: 'Twitter URL (Optional)',
    placeholder: 'Enter Twitter URL',
  },
  {
    name: 'youtubeLink',
    label: 'Youtube URL (Optional)',
    placeholder: 'Enter Youtube URL',
  },
  {
    name: 'igLink',
    label: 'Instagram URL (Optional)',
    placeholder: 'Enter Instagram URL',
  },
  {
    name: 'tiktokLink',
    label: 'TikTok URL (Optional)',
    placeholder: 'Enter TikTok URL',
  },
]

export const ArtistSocialFields = ({
  register,
  errors,
}: {
  register: UseFormRegister<IArtistValues>
  errors: FieldErrors<IArtistValues>
}) => (
  <>
    {map(SOCIAL_FIELDS, ({ name, label, placeholder }) => (
      <FormGroup key={name} label={label} error={errors?.[name]?.message}>
        <Input
          isInvalid={Boolean(errors?.[name]?.message)}
          {...register(name)}
          type="text"
          placeholder={placeholder}
        />
      </FormGroup>
    ))}
  </>
)
